const grey: Record<string, string> = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  325: '#dbdbdb',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  650: '#58595b',
  700: '#616161',
  800: '#424242',
  850: '#333333',
  900: '#212121',
};

export default grey;
